module.exports = __webpack_public_path__ + "img/banner_ad.c1426a4.png";